import {Skeleton, Table as AntdTable} from 'antd';
import * as classnames from 'classnames';
import styles from './Table.module.scss';

const Table = ({
  striped = false,
  columns = [],
  // this prevents rendering the table while the data is loading, which helps with `defaultExpandAllRows` not working.
  // the only helpful comment i've found regarding this is https://stackoverflow.com/q/61247937/1049699
  hideWhileLoading = false,
  loading,
  ...props
}) => (
  <div style={{overflowX: 'auto'}}>
    {hideWhileLoading && loading ? <Skeleton/>
      : (
        <AntdTable
          columns={columns}
          className={classnames({
            [styles.table]: true,
            [styles.tableStriped]: striped === true,
            [styles.tableStripedOdd]: striped === 'odd',
          })}
          loading={loading}
          {...props}
        />
      )}
  </div>
);

Table.Summary = AntdTable.Summary;
Table.Summary.Cell = AntdTable.Summary.Cell;
Table.Summary.Row = AntdTable.Summary.Row;

export default Table;
